import React from 'react';

type CaretIconProps = {
    className?: string;
};

export function CaretIcon({ className }: CaretIconProps) {
    return (
        <svg className={className} viewBox="0 0 10 15.999" fill="none" aria-hidden="true">
            <path d="M7.17969 7.20703C7.68268 7.71026 8.3656 7.995 9.0755 7.99802C8.49397 7.99763 7.68224 8.28928 7.17969 8.79199C6.67497 9.29688 3.06836 12.9121 3.06836 12.9121C3.06663 12.9106 3.06999 12.9137 3.06836 12.9121L3.07813 12.9209L0 15.999L0.918946 15.9971C1.6313 15.9959 2.31664 15.7118 2.82129 15.207L6.17383 11.8525L6.16406 11.8428L10 8L6.17871 4.15527C6.17685 4.15666 6.1803 4.15371 6.17871 4.15527C6.18061 4.15386 6.18783 4.14809 6.18945 4.14648L2.83692 0.791992C2.33224 0.287319 1.64785 0.00304236 0.935548 0.00195321L0.017579 0L3.09375 3.07813L3.08399 3.08789L7.17969 7.20703Z" fill="currentColor" />
        </svg>
    );
}
